<!--
 * @Date: 2024-11-19
-->
<template>
<div class="explain_tpl">
  <!-- <div v-if="isRound" class="rule_btn_round" @click="isShow=true" /> -->
  <div :class="{'explain_btn': true, 'rule_btn': !isRound}" @click="openRules"> {{ type === 'home' ? $tm(`index2024.rule.title`) : $tm(`index2024.${type}.rule.title`) }}</div>

  <van-popup
    v-model:show="isShow"
    get-container="#app"
    position="bottom"
    :style="{ height: '80vh' }"
  >
    <div class="popup_tpl">
      <div class="popup_title font_bold">{{ $tm(`index2024.rule.title`) }}
        <i class="bg_close" @click="isShow=false" />
      </div>
      <div v-if="type === 'home'" class="popup_content">
        <p class="mb_20" v-html="$tm(`index2024.rule.text`)" />
        <span v-html="$tm(`index2024.rule.text1`)" />
        <p class="title font_bold" v-html="$tm(`index2024.rule.title2`)" />
        <span v-html="$tm(`index2024.rule.text2`)" />
        <p class="mt_10">{{$tm(`index2024.rule.time`)}}</p>
      </div>
      <div v-else class="popup_content">
        <span v-if="['ownerPrincipal', 'headChef', 'youngPeople', 'restaurant'].includes(type)" v-html="$tm(`index2024.${type}.tip1`)" />
        <p class="title font_bold" v-html="$tm(`index2024.${type}.rule.ruleTitle`)" />
        <span v-html="$tm(`index2024.${type}.tip`)" />

        <!-- 规则 -->
        <div v-if="['headChef', 'ownerPrincipal', 'youngPeople', 'restaurant'].includes(type)" class="popup_content vote_content">
          <p class="title font_bold" v-html="$tm(`index2024.vote.title`)" />
          <ul class="vote_list">
            <li v-for="(text,i) in $tm(`index2024.vote.${type}`)" :key="i">
              <span v-html="text"></span>
            </li>
          </ul>
          <p class="mt_10" v-html="$tm(`index2024.vote.time1`)" />
          <p class="mt_10" v-html="$tm(`index2024.vote.time2`)" />
        </div>

        <!-- 奖项 -->
        <template v-if="$tm(`index2024.${type}.rule.ruleTitle1`) && type !== 'boss'">
          <p class="title font_bold" v-html="$tm(`index2024.${type}.rule.ruleTitle1`)" />
          <ul class="vote_list">
            <li v-for="(text,i) in $tm(`index2024.${type}.rule.awardsArr`)" :key="i"><span v-html="text"></span></li>
          </ul>
          <!-- <span v-for="(item, index) in $tm(`index2024.${type}.rule.awardsArr`)" :key="index">{{ item }}<br /></span> -->
        </template>
      </div>

    </div>
  </van-popup>
</div>
</template>

<script setup>
import { ref } from 'vue'

const props = defineProps({
  isRound: {
    type: Boolean,
    default: true
  },
  type: {
    type: String,
    default: ''
  },
  ruleTriggerCb: {
    type: Function,
    default: () => {}
  }
})
const emit = defineEmits(['ruleTrigger'])

const  isShow = ref(false)

const openRules = () => {
  isShow.value = true

  emit('ruleTrigger')
}
</script>

<style lang="scss" scoped>
@function r($px){  // 适配 375px宽
	@return $px*(1/37.5)*1rem;
}
.popup_tpl {
  margin-bottom: r(90);
}
.popup_content{
  padding: r(60) r(24) r(0);
}
.vote_content{padding: r(16) r(24) r(0) 0 !important;}
.vote_list{
  list-style: disc; 
  padding-left: r(16); 
  line-height: r(21);
  margin-left: r(10);
}
</style>
